import React from 'react';

const AccountClose = () => {
  return (
    <>
      <p>Once you close your Isibute account, it cannot be reopened.</p>
    </>
  );
};

export default AccountClose;